import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSuppliers } from '../actions/SupplierActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

class ListSuppliers extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getSuppliers(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/suppliers/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Furnizor nou
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'name', label: 'Nume'},
                    {id: 'notes', label: 'Note'},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Updated', decorator: 'date'}
                ]}

                data={this.props.data}

                onTableChange={this.handleTableChange}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                itemMenu={[
                    { getLink: (item) => `/suppliers/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/suppliers/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.suppliers;
}

export default connect(mapStateToProps)(ListSuppliers);